export const invoiceTexts = {
  et: {
    agreement: "Rendileping",
    ref: "Viitenumber",
    invoices: "Arved",
    not: "Arved puuduvad",
    download: "Lae arve alla",
    invoice: "Arve",
    status: "Staatus",

    statuses: {
      Issued: "Väljastatud",
      Sent: "Saadetud",
      Paid: "Tasunud",
    },
  },

  en: {
    agreement: "Rental Agreement",
    ref: "Reference Number",
    invoices: "Invoices",
    not: "No invoices available",
    download: "Download invoice",
    invoice: "Invoice",
    status: "Status",

    statuses: {
      Issued: "Issued",
      Sent: "Sent",
      Paid: "Paid",
    },
  },
};